import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormFeedback } from 'reactstrap';
import { ElementsConsumer } from '@stripe/react-stripe-js';

class CheckoutWithPaymentMethod extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      submitting: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitting: true });
    this.props.stripe.confirmCardPayment(this.props.client_secret, {
      payment_method: this.props.payment_method_id,
    }).then((result) => {
      if (result.error) {
        this.setState({
          error: result.error.message,
          submitting: false,
        });
        return;
      }
      this.props.submitForm();
    });
  };

  render() {
    const { error, submitting } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        {error && (<FormFeedback style={{ display: 'block' }}>{error}</FormFeedback>)}
        <Button
          className="submit"
          type="submit"
          disabled={submitting}
          color="danger"
          size="lg"
        >
          確定する
        </Button>
      </form>
    );
  }
}

CheckoutWithPaymentMethod.defaultProps = {
  elements: null,
  stripe: null,
};

CheckoutWithPaymentMethod.propTypes = {
  elements: PropTypes.shape({
    getElement: PropTypes.func.isRequired,
  }),
  stripe: PropTypes.shape({
    confirmCardPayment: PropTypes.func.isRequired,
  }),
  submitForm: PropTypes.func.isRequired,
  client_secret: PropTypes.string.isRequired,
  payment_method_id: PropTypes.string.isRequired,
};
const InjectedCheckoutWithPaymentMethod = (props) => (
  <ElementsConsumer>
    {({ stripe, elements }) => <CheckoutWithPaymentMethod stripe={stripe} elements={elements} {...props} />}
  </ElementsConsumer>
);
export default InjectedCheckoutWithPaymentMethod;
